import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';

const Header = ({ auth: { isAuthenticated, loading }, logout }) => {
    return (
        <header>
            <Link to='/QRcode'>
                <img src={require('../../images/subaru.png')} alt='' />
            </Link>
            {!loading && isAuthenticated
                ? (<div className='nav'>
                    <Link to='/QRcode'>Home</Link>
                    <Link to='/' onClick={logout}>Logout</Link>
                </div>)
                : ''}
        </header>
    );
};

const mapStateToProps = state => ({
    auth: state.auth
});

Header.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

export default connect(
    mapStateToProps,
    { logout }
)(Header);
